import * as React from 'react';
import { Subscribe } from 'unstated';

import StateContainer from '../StateContainer';
import ProductCombinationsTable from './ProductCombinationsTable';
import AttributesQuery from '../../../../components/Query/Attributes';

export interface IProductVariantsTabProps {
  currency: GQL.ICurrency;
  container: StateContainer;
  shouldUpdate: boolean;
}

export class ProductVariantsTab extends React.Component<IProductVariantsTabProps> {
  public shouldComponentUpdate() {
    return this.props.shouldUpdate;
  }

  public render() {
    const { container, currency } = this.props;

    return (
      <AttributesQuery>
        {({ attributes }: any) => {
          if (attributes.attributes) {
            return (
              <Subscribe to={[ container ]}>
                {productDetail => (
                  <ProductCombinationsTable
                    currency={currency}
                    onChange={variants => this.onChange('variants', variants)}
                    product={productDetail.state.product || {}}
                    variants={productDetail.state.product.variants || []}
                    productAttributes={container.getAllAttributesFromVariants(attributes.attributes)}
                    allAttributes={attributes.attributes}
                    container={container}
                  />
                )}
              </Subscribe>
            );
          }

          return null;
        }}
      </AttributesQuery>
    );
  }

  private async onChange(key: string, val: any) {
    if (key === 'variants') {
      if (Array.isArray(val) && val.length === 0) {
        await this.props.container.onChange('display', false);
      }
    }

    this.props.container.onChange(key, val);
  }
}



// WEBPACK FOOTER //
// ./src/scenes/Products/ProductDetail/ProductVariantsTab/ProductVariantsTab.tsx